import { Button, cn } from "@ac-expo/ui-components";

export type EmbedNavigationProps = {
  setPreviousStep?: () => void;
  setNextStep?: () => void;
  isNextStepDisabled?: boolean;
  isPreviousStepDisabled?: boolean;
  isNextStepSubmit?: boolean;
  hideNextStep?: boolean;
  nextStepLabel?: string;
};

export function EmbedNavigation({
  setPreviousStep,
  setNextStep,
  isNextStepDisabled,
  isPreviousStepDisabled,
  isNextStepSubmit,
  hideNextStep,
  nextStepLabel = "Suivant",
}: EmbedNavigationProps) {
  return (
    <div
      className={cn("mt-4 flex w-full flex-row justify-between", {
        "justify-end": !setPreviousStep,
      })}
    >
      {setPreviousStep && (
        <Button variant={"blue"} onClick={setPreviousStep} disabled={isPreviousStepDisabled}>
          Précédent
        </Button>
      )}

      {(setNextStep || isNextStepSubmit) && !hideNextStep && (
        <Button
          variant={"blue"}
          onClick={setNextStep}
          disabled={isNextStepDisabled}
          type={isNextStepSubmit ? "submit" : "button"}
        >
          {nextStepLabel}
        </Button>
      )}
    </div>
  );
}
